import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { InputNumber } from 'antd';
import Select from 'react-virtualized-select';

import PopoverError from './popoverError';
import { ordenarAlfabeticamentPerAtribut } from '../../commons/ordenacio';
import { numeroDeDecimalsCoordenades } from '../../constants';

const maxBounds = [
    [43, -0.06],
    [40.37, 3.57]
];

const LATITUD_MIN = maxBounds[1][0];
const LATITUD_MAX = maxBounds[0][0];
const LONGITUD_MIN = maxBounds[0][1];
const LONGITUD_MAX = maxBounds[1][1];

//Pic més alt de Catalunya: Pica d’Estats
const ALTITUD_MIN = 0;
const ALTITUD_MAX = 3143;

/**
 * A partir d'una llista d'objectes indexats per codiINE(normalitzat), retorna un array on cada element del array
 * es un objecte que conté el codiINe, nom i coordenades. L'array resultant esta ordenat pel nom del municipis de formar
 * ascendent.
 * @param {Object} municipis
 * @return {Array}
 */
const ordenarMunicipis = (municipis) => {

    if (!municipis) {
        return [];
    }

    //Es crea un array amb els municipis. S'havia fet la prova amb entries(), pero al fer els test amb jest fallaven pel Object.entries()
    const municipisAsArray = Object.keys(municipis).map((codiINE) => {
        const municipi = municipis[codiINE];
        return {
            value: codiINE,
            label: municipi.nom,
            className: 'Select-outer-item'
        };
    });

    return municipisAsArray.sort(ordenarAlfabeticamentPerAtribut('label'));
};

class LocalitzacioIntroduccioCamps extends Component {

    constructor(props) {
        super(props);

        this.state = {
            municipi: undefined,
            coordenades: {
                latitud: (props.coordenades) ? props.coordenades.latitud : null,
                longitud: (props.coordenades) ? props.coordenades.longitud : null
            }
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.coordenades) {
            this.setState({...this.state, coordenades: nextProps.coordenades});
        }
    }

    onChangeMunicipi(codiMunicipi) {
        const currentState = this.state;

        //S'ha de cercar les coordenades del municipi al llistat de municipis
        const { municipis } = this.props;
        const municipi = municipis[codiMunicipi];

        // Si s'ha trobat, s'ha d'actualitzar les coordenades al reducer
        if (municipi && municipi.coordenades) {
            const { coordenades } = municipi;
            // Primer canviem el municipi de l'estat actual i, desprès, llencem un callback per canviar les coordenades
            this.setState({ ...currentState, municipi: codiMunicipi, coordenades },
                () => this.props.onChangeCoordenades(coordenades)
            );
        } else { //vull netejar el municipi, no netejo coordenades
            this.setState({...currentState, municipi: codiMunicipi});
        }
    }

    onChangeLatitud(latitudSeleccionada) {
        const latitud = (latitudSeleccionada !== undefined) ? latitudSeleccionada : null;
        this.setState({...this.state, coordenades: {...this.state.coordenades, latitud}});
    }

    onChangeLongitud(longitudSeleccionada) {
        const longitud = (longitudSeleccionada !== undefined) ? longitudSeleccionada : null;
        this.setState({...this.state, coordenades: {...this.state.coordenades, longitud}});
    }

    onChangeAltitud(altitudSeleccionada) {
        const altitud = (altitudSeleccionada !== undefined) ? altitudSeleccionada : null;
        this.props.onChangeAltitud(altitud);
    }

    onBlurLatitud() {
        const novesCoordenades = { ...this.state.coordenades, latitud: this.state.coordenades.latitud };
        this.props.onChangeCoordenades(novesCoordenades);
    }

    onBlurLongitud() {
        const novesCoordenades = { ...this.state.coordenades, longitud: this.state.coordenades.longitud };
        this.props.onChangeCoordenades(novesCoordenades);
    }

    render() {
        const { municipi } = this.state;
        const { municipis, altitud, errorsCoordenades, classeCss } = this.props;
        const errorLatitud = errorsCoordenades.latitud;
        const errorLongitud = errorsCoordenades.longitud;
        const municipisEnFormatArray = ordenarMunicipis(municipis);

        return (
            <div className={classeCss}>
                <div className='municipis' id={'selector-scrollable-municipis'}>
                    <span className='titol'>Municipi:</span>
                    <Select
                        options={municipisEnFormatArray}
                        simpleValue
                        noResultsText='Municipi no trobat'
                        className='selector'
                        placeholder='Selecciona un municipi'
                        value={municipi}
                        clearable={false}
                        onChange={(municipi) => this.onChangeMunicipi(municipi)}
                        maxHeight={145}>
                    </Select>
                </div>

                <div className='variables'>
                    <span className='titol'>Latitud:</span>
                    <InputNumber
                        className='input-number'
                        min={LATITUD_MIN}
                        max={LATITUD_MAX}
                        step={1/(Math.pow(10, numeroDeDecimalsCoordenades))}
                        onChange={(latitud) => this.onChangeLatitud(latitud)}
                        onBlur={() => this.onBlurLatitud.call(this)}
                        value={this.state.coordenades.latitud}
                        precision={numeroDeDecimalsCoordenades}
                    />
                    &nbsp;°
                    {errorLatitud ? <PopoverError contingut='Camp obligatori' classNameIcona='icona-error' /> : null}
                </div>
                <div className='variables'>
                    <span className='titol'>Longitud:</span>
                    <InputNumber
                        className='input-number'
                        min={LONGITUD_MIN}
                        max={LONGITUD_MAX}
                        step={1/(Math.pow(10, numeroDeDecimalsCoordenades))}
                        onChange={(longitud) => this.onChangeLongitud(longitud)}
                        onBlur={() => this.onBlurLongitud.call(this)}
                        value={this.state.coordenades.longitud}
                        precision={numeroDeDecimalsCoordenades}
                    />
                    &nbsp;°
                    {errorLongitud ? <PopoverError contingut='Camp obligatori' classNameIcona='icona-error' /> : null}
                </div>
                <div className='variables'>
                    <span className='titol'>Altitud:</span>
                    <InputNumber
                        className='input-number'
                        min={ALTITUD_MIN}
                        max={ALTITUD_MAX}
                        step={1}
                        onChange={(altitud) => this.onChangeAltitud(altitud)}
                        value={altitud}
                    />
                    &nbsp;m
                </div>
            </div>
        );
    }
}

LocalitzacioIntroduccioCamps.propTypes = {
    municipis: PropTypes.object,
    coordenades: PropTypes.object,
    altitud: PropTypes.number,
    errorsCoordenades: PropTypes.object,
    classeCss: PropTypes.string,
    onChangeCoordenades: PropTypes.func,
    onChangeAltitud: PropTypes.func
};

export default LocalitzacioIntroduccioCamps;



// WEBPACK FOOTER //
// ./src/components/commons/localitzacioIntroduccioCamps.js